import { createElement } from './globalFunctions'

/**
 * Creates a tab link for the SHP tabs.
 * @param {string} text - Text of the tab
 * @param {string} anchor - Anchor of the tab
 * @returns {HTMLElement} - Created tab link
 */
const createShpTabLink = (text, anchor) => {
	const shpTabLi = createElement('li', ['shp-tab'])
	const shpTabLink = createElement('a', ['shp-tab-link'], text)
	shpTabLink.href = anchor
	shpTabLi.appendChild(shpTabLink)
	return shpTabLi
}

/**
 * Removes the tabs switcher from the SHP tabs.
 * Used for convert switching tabs to anchors.
 */
const removeTabsSwitcher = () => {
	const shpTabLinks = document.querySelectorAll('.shp-tab-link')
	if (shpTabLinks.length === 0) return
	for (const tabLink of shpTabLinks) {
		tabLink.removeAttribute('role')
		tabLink.removeAttribute('data-toggle')
	}
}
const pInfoWrapper = document.querySelector('.p-info-wrapper')

const handleProductTop = () => {
	const detailInfo = document.querySelector('.p-detail-info')
	const productTitle = document.querySelector('.p-detail-inner-header h1')
	const code = document.querySelector('.p-detail-inner-header .p-code')
	// const giftsWrapper = document.querySelector('.p-gifts-wrapper')

	if (pInfoWrapper) {
		if (detailInfo) {
			pInfoWrapper.prepend(detailInfo)

			detailInfo.prepend(productTitle)
			// if (giftsWrapper) detailInfo.append(giftsWrapper)
			if (code) detailInfo.append(code)
		}
	}
}

const createAddToCartWrapper = () => {
	const addToCartWrapper = createElement('div', ['add-to-cart-wrapper'])
	const addToCartParent = document.querySelector('.add-to-cart')
	const addToCartBtn = document.querySelector('.add-to-cart .btn')
	const availability = document.querySelector('.availability-value')
	const priceWrapper = document.querySelector('.p-final-price-wrapper')
	// const flagsExtra = document.querySelector('.p-image .flags-extra')

	// if (flagsExtra) addToCartWrapper.appendChild(flagsExtra)
	if (availability) addToCartWrapper.appendChild(availability)
	if (priceWrapper) addToCartWrapper.appendChild(priceWrapper)
	if (addToCartParent) addToCartWrapper.appendChild(addToCartParent)
	if (pInfoWrapper) pInfoWrapper.appendChild(addToCartWrapper)
	const quantity = document.querySelector('.add-to-cart .quantity')
	if (quantity && addToCartParent) addToCartParent.before(quantity)
	// if (addToCartBtn) addToCartBtn.textContent = window.language === 'cs' ? 'Do košíku' : 'Do košíka'
}

const moveTabsOnDetail = () => {
	const relatedFiles = document.querySelector('#relatedFiles')
	const basicDescription = document.querySelector('.basic-description')
	const extendedDescription = document.querySelector('.extended-description')
	const productsRelated = document.querySelector('.products-related')
	const relatedHeader = document.querySelector('.products-related-header')
	const tabContent = document.querySelector('#tab-content')
	const description = document.querySelector('#description')
	if (description) description.classList.remove('tab-pane', 'fade')
	if (productsRelated) {
		tabContent.after(productsRelated)
	}
	if (relatedHeader) tabContent.after(relatedHeader)

	if (basicDescription) {
		const heading = basicDescription.querySelector('h3')
		if (heading)
			heading.textContent =
				window.language === 'cs' ? 'Popis produktu' : 'Popis produktu'
	}
	if (extendedDescription) {
		const heading = extendedDescription.querySelector('h3')
		const table = extendedDescription.querySelector('table.detail-parameters')
		if (heading)
			heading.textContent = window.language === 'cs' ? 'Parametry' : 'Parametre'
		if (table) {
			const thead = createElement('thead')
			const tr = createElement('tr')
			const th1 = createElement(
				'th',
				[],
				window.language === 'cs' ? 'Parametr' : 'Parameter'
			)
			const th2 = createElement(
				'th',
				[],
				window.language === 'cs' ? 'Hodnota' : 'Hodnota'
			)
			tr.append(th1, th2)
			thead.appendChild(tr)
			table.prepend(thead)

			const links = table.querySelectorAll('a + a')
			if (links.length) {
				for (let link of links) {
					const parentTd = link.parentElement
					if (parentTd)
						parentTd.innerHTML = parentTd.innerHTML.replace('>,', '> ')
				}
			}
		}
	}
	if (relatedFiles) {
		relatedFiles.classList.remove('tab-pane', 'fade')
		relatedFiles.removeAttribute('role')
		const filesHeading = createElement(
			'h3',
			['files-heading'],
			window.language === 'cs' ? 'Ke stažení' : 'Na stiahnutie'
		)
		const filesWrapper = createElement('div', ['related-files'])
		filesWrapper.appendChild(filesHeading)
		filesWrapper.appendChild(relatedFiles)
		if (tabContent) tabContent.appendChild(filesWrapper)
		// if (basicDescription) {
		// 	basicDescription.appendChild(filesHeading)
		// 	basicDescription.appendChild(relatedFiles)
		// }

		const relatedFilesTab = document.querySelector(
			'a.shp-tab-link[href="#relatedFiles"]'
		)
		if (relatedFilesTab) {
			relatedFilesTab.removeAttribute('role', 'data-toggle')
			relatedFilesTab.removeAttribute('data-toggle')
			relatedFilesTab.textContent =
				window.language === 'cs' ? 'Ke stažení' : 'Na stiahnutie'
		}
	}
	const productVideos = document.querySelector('#productVideos')
	if (productVideos) {
		productVideos.classList.remove('tab-pane', 'fade')
		const videosTab = document.querySelector(
			'a.shp-tab-link[href="#productVideos"]'
		)
		if (videosTab) {
			videosTab.removeAttribute('role')
			videosTab.removeAttribute('data-toggle')
		}
		const videoHeading = productVideos.querySelector('h3')
		if (videoHeading)
			videoHeading.textContent = window.language === 'cs' ? 'Video' : 'Video'
		// if (extendedDescription) extendedDescription.appendChild(productVideos)
	}
	const productsAlternative = document.querySelector('#productsAlternative')
	if (productsAlternative) {
		productsAlternative.classList.remove('tab-pane', 'fade')
		productsAlternative.classList.add('container')
		productsAlternative.removeAttribute('role')
		const pDetail = document.querySelector('.p-detail')
		const alternativeHeading = createElement(
			'h2',
			['alternative-heading'],
			'Podobné produkty'
		)
		productsAlternative.prepend(alternativeHeading)
		const products = productsAlternative.querySelector('.products')
		const slickSettings = {
			slidesToShow: 4,
			infinite: false,
			dots: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						arrows: false,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2,
						dots: false,
						arrows: false,
					},
				},
			],
		}
		if (products) $(products).slick(slickSettings)
		if (pDetail) pDetail.appendChild(productsAlternative)
	}
}

const turnProductImgToCarousel = () => {
	const thumbnails = document.querySelectorAll('.p-thumbnail')

	if (thumbnails.length) {
		let mainImage = document.querySelector('.p-image > .p-main-image'),
			productImage = document.querySelector('.product-top .p-image-wrapper'),
			sliderWrapper = document.createElement('div')

		sliderWrapper.classList.add('custom-slider-wrapper')
		sliderWrapper.appendChild(mainImage)

		thumbnails.forEach((thumb, index) => {
			if (index > 0) {
				let imgUrl = thumb.getAttribute('href'),
					aEl = document.createElement('a'),
					imgEl = document.createElement('img')
				aEl.classList.add('p-main-image')
				aEl.href = imgUrl
				aEl.appendChild(imgEl)
				imgEl.src = imgUrl
				sliderWrapper.appendChild(aEl)
			}
		})

		productImage.querySelector('.p-image').appendChild(sliderWrapper)
		$(sliderWrapper).slick({
			infinite: false,
			arrows: false,
			slidesToShow: 1.1,
			slidesToScroll: 1,
			dots: true,
		})
	}
}

// moves favorites icon to the to social buttons and changes text in the icon
const handleFavoritesIcon = () => {
	const favoritesIcon = document.querySelector('#dkLabFavouriteDiv')
	const socialIcons = document.querySelector(
		'.social-buttons-wrapper .link-icons'
	)
	if (favoritesIcon && socialIcons) socialIcons.prepend(favoritesIcon)
	const favSpan = document.querySelector('#dkLabFavDetailSpan span')
	if (favSpan)
		favSpan.textContent = window.language === 'cs' ? 'Oblíbené' : 'Obľúbené'
}

// moves flags to the image. Merges default flags with extra flags
const handleFlagsOnDetail = () => {
	const flagsDefault = document.querySelector('.p-detail-info .flags-default')
	const flagsExtra = document.querySelector('.p-image .flags-extra')
	const productImage = document.querySelector('.p-image')
	if (flagsDefault) {
		if (flagsExtra) {
			flagsDefault.appendChild(flagsExtra)
			flagsDefault.classList.add('contains-extra')
		}
		productImage.appendChild(flagsDefault)
	}
	// else if (flagsExtra) {
	// 	productImage.appendChild(flagsExtra)
	// }
}

const changeTextOfLinkToDescription = () => {
	const linkToDesc = document.querySelector(
		"p[data-testid='productCardDescr'] a"
	)
	if (linkToDesc)
		linkToDesc.textContent =
			window.language === 'cs' ? 'Zobrazit více' : 'Zobrazit viac'
}
export {
	createShpTabLink,
	removeTabsSwitcher,
	handleProductTop,
	createAddToCartWrapper,
	moveTabsOnDetail,
	turnProductImgToCarousel,
	handleFavoritesIcon,
	handleFlagsOnDetail,
	changeTextOfLinkToDescription,
}
